import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { useGetPreviousYearInfo } from 'Containers/Filing/hooks';
import { ResultTypes, taxReturnFilingType } from 'Types/common';
import * as Styled from './styles';
import { QuestionListProps } from './types';
import { getQuestionType, frecuentQuestionsByType } from './utils';

const QuestionList = ({ data }: QuestionListProps): JSX.Element => {
  const previousYearInfo = useGetPreviousYearInfo();
  const { mandatory } = data;
  const { t } = useTranslation(locizeNS.RESULT);
  const questionType = getQuestionType(data, previousYearInfo);
  const isComplementary =
    data?.taxReturnFilingType === taxReturnFilingType.complementary &&
    data?.taxReturnType === ResultTypes.toReturn;
  return (
    <Styled.QuestionsContainer id="question-content">
      {isComplementary ? (
        <Styled.DetailAccordion size="S">
          <Text type="paragraphs" color="dark" size="S_L_S">
            {t(`Result.fed.question`)}
          </Text>
          <FlexContainer direction="column" gap="dimension_16">
            <FlexContainer direction="column">
              {Array.from({ length: 4 }).map((_, index: number) => (
                <Styled.StyledList key={`fed-answer-${index + 1}`}>
                  <li>
                    <Text type="paragraphs" color="dark" size="S_S_S">
                      {t(`Result.fed.${index + 1}.answer`)}
                    </Text>
                  </li>
                </Styled.StyledList>
              ))}
            </FlexContainer>
            <Text type="paragraphs" color="dark" size="S_S_S">
              {t(`Result.fed.answer`)}
            </Text>
          </FlexContainer>
        </Styled.DetailAccordion>
      ) : (
        <>
          {frecuentQuestionsByType[questionType].questionsAndAnswers.map(item => (
            <Styled.DetailAccordion size="S" key={item.question}>
              <Text type="paragraphs" color="dark" size="S_L_S">
                {t(item.question)}
              </Text>
              <Text type="paragraphs" color="dark" size="S_S_S">
                {t(item.answer)}
              </Text>
            </Styled.DetailAccordion>
          ))}
          {mandatory && (
            <Styled.DetailAccordion size="S">
              <Text type="paragraphs" color="dark" size="S_L_S">
                {t(`Result.${data.taxReturnType}.mandatory.question`)}
              </Text>
              <Text type="paragraphs" color="dark" size="S_S_S">
                {t(`Result.${data.taxReturnType}.mandatory.answer`)}
              </Text>
            </Styled.DetailAccordion>
          )}
          <Styled.DetailAccordion size="S">
            <Text type="paragraphs" color="dark" size="S_L_S">
              {t('Result.improvements.first.question')}
            </Text>
            <Text type="paragraphs" color="dark" size="S_S_S">
              {t('Result.improvements.first.answer')}
            </Text>
          </Styled.DetailAccordion>
        </>
      )}
    </Styled.QuestionsContainer>
  );
};

export default QuestionList;
